// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Message_avatar_8uNKY","transparent":"Message_transparent_1gJHs","typing":"Message_typing_3gceh"};